export default __webpack_public_path__ + "static/media/pin-shuen-wan-typhoon-shelter.a2e74ec9.png";